import axios from 'axios';

const generateAppLink = (item, store) => {
  let link = '';

  if (store === 'itunes') {
    link = `https://apps.apple.com/us/app/id${item.s}`;
  } else if (store === 'google_play') {
    link = `https://play.google.com/store/apps/details?id=${item.p}`;
  }

  return link;
};

const generateCompanyLink = (item, store) => {
  let link = '';

  if (store === 'itunes') {
    link = item.cl;
  } else if (store === 'google_play') {
    link = `https://play.google.com/store/apps/developer?id=${item.cn}`;
  }

  return link;
};

const Game = {
  namespaced: true,
  state: {
    error: null,
    /** @var a single selected game */
    game: null,
    gameList: {
      itunes: [],
      google_play: [],
    },
    isLoading: false,
    updatedAt: {
      itunes: null,
      google_play: null,
    },
    listMetadata: null,
    filters: {
      publisher: null,
      store: 'itunes',
    },
  },
  getters: {
    game: (state) => state.game,
    gameList: (state) => state.gameList[state.filters.store],
    gameListItunes: (state) => state.gameList.itunes,
    gameListGooglePlay: (state) => state.gameList.google_play,
    nbGames: (state) => state.gameList[state.filters.store].length,
    filteredGameList(state) {
      const gameList = state.gameList[state.filters.store];

      if (state.filters.publisher) {
        return gameList.filter((item) => item.companyName && item.companyName.toLowerCase() === state.filters.publisher);
      }

      return gameList;
    },
    nbVoodooGames(state) {
      const gameList = state.gameList[state.filters.store];

      // some data may be invalid, with undefined company names
      return gameList.filter((item) => item.companyName && item.companyName.toLowerCase() === 'voodoo').length;
    },
    filters: (state) => state.filters,
    updatedAt: (state) => state.updatedAt[state.filters.store],
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
  },
  mutations: {
    setGame(state, game) {
      // eslint-disable-next-line no-param-reassign
      state.game = game;
    },
    resetError(state) {
      // eslint-disable-next-line no-param-reassign
      state.error = null;
    },
    setError(state, msg) {
      // eslint-disable-next-line no-param-reassign
      state.error = msg;
    },
    setIsLoading(state, isLoading) {
      // eslint-disable-next-line no-param-reassign
      state.isLoading = isLoading;
    },
    setGameList(state, gameList) {
      // eslint-disable-next-line no-param-reassign
      state.gameList[state.filters.store] = gameList;
    },
    setUpdatedAt(state, updatedAt) {
      // eslint-disable-next-line no-param-reassign
      state.updatedAt[state.filters.store] = updatedAt;
    },
    setListMetadata(state, metadata) {
      // eslint-disable-next-line no-param-reassign
      state.listMetadata = metadata;
    },
    setFilterPublisher(state, publisher) {
      // eslint-disable-next-line no-param-reassign
      state.filters.publisher = publisher ? publisher.toLowerCase() : null;
    },
    setFilterStore(state, storeName) {
      // eslint-disable-next-line no-param-reassign
      state.filters.store = storeName;
    },
    resetLists(state) {
      // eslint-disable-next-line no-param-reassign
      state.gameList = {
        itunes: [],
        google_play: [],
      };

      // eslint-disable-next-line no-param-reassign
      state.updatedAt = {
        itunes: null,
        google_play: null,
      };

      // eslint-disable-next-line no-param-reassign
      state.listMetadata = null;
    },
  },
  actions: {
    setFilters({ commit, dispatch, state }, { storeName, publisher }) {
      commit('setFilterStore', storeName);
      commit('setFilterPublisher', publisher);

      if (state.gameList[storeName].length === 0) {
        dispatch('fetchGameList');
      }
    },
    setFilterStore({ commit, dispatch, state }, storeName) {
      commit('setFilterStore', storeName);

      if (state.gameList[storeName].length === 0) {
        dispatch('fetchGameList');
      }
    },
    async fetchGameList({ commit, state }, resetAll = false) {
      commit('resetError');
      commit('setIsLoading', true);

      try {
        if (resetAll) {
          commit('resetLists');
        }

        const baseUrl = process.env.VUE_APP_DATA_BASE_URL || '';

        const params = baseUrl ? { headers: { 'Access-Control-Allow-Origin': '*' } } : {};
        const url = `${baseUrl}/data/metadata.json`;
        const metadata = state.listMetadata || await axios.get(url, params).then((res) => res.data);
        const response = await axios.get(`${baseUrl}/data${metadata[state.filters.store].file_name}`, params).then((res) => res.data);
        const updatedAt = new Date(metadata[state.filters.store].updated_at);

        let games = null;

        if (response.games.length && response.games[0].name) {
          // old version of datasets, more verbose, to be removed
          games = response.games.map((item, index) => ({
            storeId: item.store_id,
            name: item.name,
            icon: item.icon_s,
            icon_s: item.icon_s,
            icon_l: item.icon_l,
            companyName: item.company_name,
            storeAppLink: item.store_app_link,
            storeCompanyLink: item.store_company_link,
            index,
          }));
        } else {
          games = response.games.map((item, index) => ({
            storeId: item.s,
            name: item.n,
            icon: item.is,
            icon_s: item.is,
            icon_l: item.il,
            companyName: item.cn,
            storeAppLink: generateAppLink(item, state.filters.store),
            storeCompanyLink: generateCompanyLink(item, state.filters.store),
            index,
          }));
        }

        commit('setGameList', games);
        commit('setListMetadata', metadata);
        commit('setUpdatedAt', updatedAt);
      } catch (err) {
        commit('setError', err.message);
      }

      commit('setIsLoading', false);
    },
  },
};

export default Game;
